module.exports = __webpack_public_path__ + "45f8fe9813f055a682b2fbc6aba2b43b.png";